import React, { useState, useRef, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Autocomplete
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px"
};

const center = {
  lat: 1.2824,
  lng: 103.8436
};

const MapComponent = ({onShapesUpdate, zoneCoordinationPoint}) => {
  const [mapCenter, setMapCenter] = useState(center);
  const [marker, setMarker] = useState(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
  if (zoneCoordinationPoint !== null) {
    setMarker(zoneCoordinationPoint);
    setMapCenter(zoneCoordinationPoint);
  }
}, [zoneCoordinationPoint]);



  const onLoadAutocomplete = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();

    const location = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    };

    setMapCenter(location);
    setMarker(location);
    onShapesUpdate('latlong', location)
  };

  const onMarkerDragEnd = (e) => {
    const newPosition = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng()
    };
    console.log(newPosition, 'newPosition')
    setMarker(newPosition);
    onShapesUpdate('latlong', newPosition)
  };
  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_MAPKEY}
      libraries={["places"]}
    >
      <Autocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
        <input
          type="text"
          placeholder="Search location"
          className="googlemap-search-input"
          style={{
            width: "300px",
            height: "40px",
            marginBottom: "10px"
          }}
        />
      </Autocomplete>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        zoom={marker!==null?18:12}
      >
        {marker && (
          <Marker
            position={marker}
            draggable={true}
            onDragEnd={onMarkerDragEnd}
          />
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapComponent;